<mat-card *ngIf="dataSource.data?.length > 0">
  <div class="panel-request__card-header" fxLayout="row wrap" fxLayoutAlign="space-between center">
    <h2>
      {{ this.data.establishmentName }}
    </h2>
  </div>
  <mat-card-content>
    <div class="table__wrapper">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="codBeneficiary">
          <th mat-header-cell *matHeaderCellDef class="fixed" translate>penalty.excel.codBenef</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left fixed">
            {{ element.codBeneficiary }}
          </td>
        </ng-container>
        <ng-container matColumnDef="beneficiary">
          <th mat-header-cell *matHeaderCellDef class="fixed" translate>penalty.excel.beneficiary</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left fixed">
            {{ element.beneficiary }}
          </td>
        </ng-container>
        <ng-container matColumnDef="contractId">
          <th mat-header-cell *matHeaderCellDef translate>penalty.excel.contractNumber</th>
          <td mat-cell *matCellDef="let element">{{ element.contractId }}</td>
        </ng-container>
        <ng-container matColumnDef="holderName">
          <th mat-header-cell *matHeaderCellDef translate>penalty.excel.clientName</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left">{{ element.holderName }}</td>
        </ng-container>
        <ng-container matColumnDef="productDesc">
          <th mat-header-cell *matHeaderCellDef class="fixed" translate>penalty.excel.product</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left fixed">
            {{ element.productDesc }}
          </td>
        </ng-container>
        <ng-container matColumnDef="autDate">
          <th mat-header-cell *matHeaderCellDef translate>penalty.excel.date</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left">
            {{ element.autDate }}
          </td>
        </ng-container>
        <ng-container matColumnDef="amountPenalty">
          <th mat-header-cell *matHeaderCellDef translate>penalty.excel.amountPenalty</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left">
            {{ element.sign }} {{ getIncentive(element.amountPenalty) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="reason">
          <th mat-header-cell *matHeaderCellDef translate>penalty.excel.reason</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left">
            {{ getReason(element.sign, element.reason, element.penalty) }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <div fxLayout="row" class="buttons-paginator" style="justify-content: flex-end" *ngIf="this.totalPages > 1">
      <button
        id="previousPageRequestPanel"
        mat-flat-button
        class="panel-request__card-footer--buttons"
        *ngIf="currentPage !== 1"
        (click)="changePage(1)"
      >
        <mat-icon [class]="'icon-ic_to_beginning'"></mat-icon>
      </button>
      <button
        id="previousPageRequestPanel"
        mat-flat-button
        class="panel-request__card-footer--buttons"
        *ngIf="currentPage !== 1"
        (click)="changePage(currentPage - 1)"
      >
        <mat-icon [class]="'icon-ic_chevron_left'"></mat-icon>
      </button>
      <button
        id="nextPageRequestPanel"
        mat-flat-button
        class="panel-request__card-footer--buttons"
        *ngIf="totalPages !== currentPage"
        (click)="changePage(currentPage + 1)"
      >
        <mat-icon [class]="'icon-ic_chevron_right'"></mat-icon>
      </button>
      <button
        id="previousPageRequestPanel"
        mat-flat-button
        class="panel-request__card-footer--buttons"
        *ngIf="totalPages !== currentPage"
        (click)="changePage(totalPages)"
      >
        <mat-icon [class]="'icon-ic_to_end'"></mat-icon>
      </button>
    </div>
  </mat-card-content>
</mat-card>
